import createMutator from '../../utils/createMutator';

export const setWindowWidth = createMutator('set', 'windowWidth');